import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgFile() {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("path", {
      clipRule: "evenodd",
      d: "M16.586 1.586A2 2 0 0015.172 1H5C3.757 1 3 2 3 3v18c0 1.215.757 2 2 2h13.973C20.216 23 21 22.215 21 21V6.828a2 2 0 00-.586-1.414l-3.828-3.828z",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), _jsx("path", {
      d: "M15 2v4a1 1 0 001 1h4",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), _jsx("path", {
      stroke: "currentColor",
      strokeWidth: 1.8,
      strokeLinecap: "round",
      d: "M7.9 13.1h8.2M7.9 17.1h8.2"
    }, void 0)]
  }), void 0);
}

export default SvgFile;